<app-modal-card [visible]="visible" (close)="close.emit()" data-testid="modal-bankid-dev">
	<h1 class="mb-6 text-xl text-center">Dev SSN</h1>
	<p class="mb-2 text-sm">Enter the SSN of the user you want to use to pass the BankID identify step, or click continue to use default SSN.</p>
	<form *ngIf="ssnForm" class="flex flex-col w-full" [formGroup]="ssnForm">
		<app-input class="w-full" label="SSN" name="ssn" type="text" formControlName="ssn" data-testid="input-bankid-ssn"></app-input>
		<app-button (click)="continueClicked()" data-testid="button-bankid-continue">Continue</app-button>
	</form>
</app-modal-card>
